import { render, staticRenderFns } from "./columnchart.vue.html?vue&type=template&id=b307cab4"
import script from "./columnchart.controller.ts?vue&type=script&lang=js&external"
export * from "./columnchart.controller.ts?vue&type=script&lang=js&external"
import style0 from "./columnchart.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports